<!--
- 活动列表
- author: wang.y
- 创建时间: 2019-12-10
-->
<template>
<div>
  <DataNavigation></DataNavigation>
  <div class="a-list index_content">
    <div class="list-l ivu-layout-sider">
      <div class="right_column">
        <div class="keyword-input">
          <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch" />
        </div>
        <div class="rigit_title">
          <span>筛选</span>
          <Dropdown trigger="click" placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
            <a href="javascript:void(0)">
              <span>{{screen_active}}</span>
              <Icon type="md-arrow-dropup" v-if="drop_val" />
              <Icon type="md-arrow-dropdown" v-else />
            </a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="rigit_content">
          <div class="screen_ul">
            <div class="screen_li" v-show="screen_active === '全部' || screen_active === '会议时间'">
              <div class="screen_tle" @click="screen_tle.days = !screen_tle.days">
                <span>会议时间</span>
                <Icon type="md-add" v-if="!screen_tle.days" />
                <Icon type="md-remove" v-else />
              </div>
              <div class="screen_cnt" v-show="screen_tle.days">
                <RadioGroup v-model="params.days" vertical @on-change="clearGetList">
                  <Radio label=""><span>不限</span></Radio>
                  <Radio v-for="item in days" :key="item.id" :label="item.id"><span>{{item.name}}({{days_num['day_' + (parseInt(item.id) + 1)] | empty(0)}})</span></Radio>
                </RadioGroup>
              </div>
            </div>
            <div class="screen_li" v-show="screen_active === '全部' || screen_active === '会议类型'">
              <div class="screen_tle" @click="screen_tle.type = !screen_tle.type">
                <span>会议类型</span>
                <Icon type="md-add" v-if="!screen_tle.type" />
                <Icon type="md-remove" v-else />
              </div>
              <div class="screen_cnt" v-show="screen_tle.type">
                <RadioGroup v-model="params.type" vertical @on-change="clearGetList">
                  <Radio label=""><span>不限</span></Radio>
                  <Radio v-for="item,index of meta.forum_type" :label="index" :key="index"><span>{{item}}({{item | dealName(type_num, 'forum_type', 'num', 0)}})</span></Radio>
                </RadioGroup>
              </div>
            </div>
            <div class="screen_li" v-show="screen_active === '全部' || screen_active === '地域选择'">
              <div class="screen_tle" @click="screen_tle.province = !screen_tle.province">
                <span>地域选择</span>
                <Icon type="md-add" v-if="!screen_tle.province" />
                <Icon type="md-remove" v-else />
              </div>
              <div class="screen_cnt" v-show="screen_tle.province">
                <RadioGroup v-model="params.province" vertical @on-change="clearGetList">
                  <Radio label=""><span>不限</span></Radio>
                  <Radio v-for="item,key,index of meta.forum_province" :label="key" :key="key" v-show="index < 10 || show_all_address"><span>{{item}}({{key | dealName(province_num, 'id', 'num', 0)}})</span></Radio>
                </RadioGroup>
                <span class="more_sel" @click="show_all_address = !show_all_address">
                  <template v-if="!show_all_address">查看更多</template>
                  <template v-else>收起更多</template>
                </span>
              </div>
            </div>
            <div class="screen_li" v-show="screen_active === '全部' || screen_active === '会议规模'">
              <div class="screen_tle" @click="screen_tle.forum_scale = !screen_tle.forum_scale">
                <span>会议规模</span>
                <Icon type="md-add" v-if="!screen_tle.forum_scale" />
                <Icon type="md-remove" v-else />
              </div>
              <div class="screen_cnt" v-show="screen_tle.forum_scale">
                <RadioGroup v-model="params.forum_scale" vertical @on-change="clearGetList">
                  <Radio label=""><span>不限</span></Radio>
                  <Radio v-for="item,index in meta.forum_scale" :label="item.id" :key="index"><span>{{item.scale}}</span></Radio>
                </RadioGroup>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="list-r">
      <div class="sel_opt" v-if="haveOption && haveOption.length > 0">
        <div class="sel_tle">已选条件</div>
        <div class="sel_cnt">
          <span v-for="(item,index) in haveOption" :key="index" @click="handleCancelOption(item)">{{item.name}}
            <Icon type="md-close" />
          </span>
        </div>
        <div class="sel_clear">
          <span @click="handleClearOption"><i class="iconfont">&#xe63e;</i>清空筛选</span>
        </div>
      </div>
      <div class="list-header">
        <p>共{{total}}场活动</p>
      </div>
      <div :class="{'list-content': true, 'load': list_loading}">
        <ul>
          <li v-for="item,index in list" :key="index">
            <div class="a-img" @click="goDetail(item)">
              <img :src="item.banner_path | logo_show" />
            </div>
            <div class="a-info">
              <div class="a-title" @click="goDetail(item)">{{item.name}}</div>
              <div class="a-state">
                <img :src="$store.state.static_img_url + 'pic/activity/signup.png'" v-if="time_state(item.start_time, item.end_time) == 1" />
                <img :src="$store.state.static_img_url + 'pic/activity/loading.png'" v-if="time_state(item.start_time, item.end_time) == 2" />
                <img :src="$store.state.static_img_url + 'pic/activity/' + (theme_switch ? 'end.png' : 'end2.png')" v-if="time_state(item.start_time, item.end_time) == 3" />
              </div>
              <div class="a-address"><i class="iconfont">&#xe63a;</i>{{item.address}}</div>
              <div class="a-dec">
                <span><i class="iconfont">&#xe632;</i>{{item.start_time | time_moment('YYYY-MM-DD HH:mm')}}</span>
                <!-- <span><i class="iconfont">&#xe621;</i>免费</span> -->
                <span><i class="iconfont" v-if="item.forum_type">&#xe63c;</i>{{item.forum_type}}</span>
              </div>
            </div>
          </li>
        </ul>
        <Nothing v-if="total == 0 && !list_loading">
          <p>没有相关活动</p>
        </Nothing>
        <Spin fix v-if="list_loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </div>
      <div class="list-bottom">
        <div class="page clear" v-if="total > 10">
          <Page :total="total" :page-size="10" class="page_list" show-total show-elevator :current="params.page" @on-change="handleChangePage" />
        </div>
      </div>
    </div>

  </div>
</div>
</template>
<script>
import {
  forumList,
  forumNum
} from '../../service'
import {
  userInfo
} from 'js/userInfo'
import {
  get_meta
} from 'js/get_meta'
import {
  left_scroll
} from 'js/left_scroll'
import filter from 'js/filter'
import moment from 'moment'
import DataNavigation from '../DataList/components/DataNavigation.vue'
import { getAddPuv } from 'js/addPuv.js'
import Nothing from '@/components/Nothing2.vue'

export default {
  mixins: [userInfo, get_meta, getAddPuv, left_scroll],
  inject: ['login'],
  components: {
    DataNavigation,
    Nothing
  },
  data() {
    const _that = this
    return {
      filter: filter,
      list: [],
      total: 0,
      params: {
        type: '',
        province: '',
        days: '',
        forum_scale: '',
        keyword: '',
        page: 1
      },
      search_ipt: '',
      search_phd: '',
      screen_dropdown: ['全部', '会议时间', '会议类型', '地域选择', '会议规模'],
      screen_active: '全部',
      screen_tle: {
        type: false,
        province: false,
        days: false,
        forum_scale: false,
      },
      days: [{
          id: '6',
          name: '7日内'
        },
        {
          id: '14',
          name: '15日内'
        },
        {
          id: '29',
          name: '30日内'
        },
        {
          id: '181',
          name: '半年内'
        },
        {
          id: '364',
          name: '一年内'
        }
      ],
      show_all_address: false,
      drop_val: false,
      list_loading: true,
      days_num: '',
      province_num: '',
      type_num: ''
    }
  },
  computed: {
    theme_switch() {
      return this.$store.state.theme_switch
    },
    /**
     * 论坛状态
     * 1 可报名   2 进行中   3 已结束
     */
    time_state() {
      return function(start_time, end_time) {
        let new_time = moment()
        if (moment(new_time).isBefore(start_time)) return 1
        if (moment(new_time).isBetween(start_time, end_time)) return 2
        if (moment(new_time).isAfter(end_time)) return 3
      }
    },
    haveOption() {
      let option_keyWord = [],
        option_type = [],
        option_province = [],
        option_days = [],
        option_forum_scale = []
      if (this.params.keyword !== '') {
        option_keyWord = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword
        }
      }
      if (this.params.type !== '') {
        option_type = {
          type: 'type',
          name: this.meta.forum_type[this.params.type],
          value: this.params.type
        }
      }
      if (this.params.province !== '') {
        option_province = {
          type: 'province',
          name: this.meta.forum_province[this.params.province],
          value: this.params.province
        }
      }
      if (this.params.days !== '') {
        option_days = {
          type: 'days',
          name: filter.dealName(this.params.days, this.days),
          value: this.params.days
        }
      }
      if (this.params.forum_scale !== '') {
        option_forum_scale = {
          type: 'forum_scale',
          name: filter.dealName(this.params.forum_scale, this.meta.forum_scale, 'id', 'scale'),
          value: this.params.forum_scale
        }
      }
      return [].concat(
        option_keyWord,
        option_type,
        option_province,
        option_days,
        option_forum_scale
      )
    },
    req_url() {
      return this.$store.state.req_url
    },
    default_key() {
      let index = this.$store.state.datahotsearchkey.findIndex(a => a.position_id == '15'),
          key = ''
      if (index > -1) {
        key = this.$store.state.datahotsearchkey[index].name
      }
      return key
    }
  },
  methods: {
    async getForumList() {
      this.list_loading = true
      this.params.user_key = this.user_key
      let res = await forumList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'list', res.res)
        this.list_loading = false
        if (this.params.page == 1) this.$set(this.$data, 'total', res.count)
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 会议活动数量统计
     */
    async forumNum(t_arr) {
      let res = await forumNum({}, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'days_num', res.days[0])
        this.$set(this.$data, 'province_num', res.province)
        this.$set(this.$data, 'type_num', res.type)
        this.$forceUpdate()
      } else {
        this.$Message.error(res.message)
      }
    },
    goDetail(item) {
      window.open(filter.page(item.src_url))
    },
    handleSearch(val) {
      if (!this.list_loading) {
        if (val) {
          this.params.keyword = val
          this.search_phd = val.length > 10 ? val.substr(0, 9).concat('...') : val
          let index = this.$store.state.datahotsearchkey.findIndex(a => a.position_id == '15')
          if (index > -1) {
            this.$store.state.datahotsearchkey[index].name = val
          }
          this.$store.commit('updateDatahotsearchkey', this.$store.state.datahotsearchkey)
        } else {
          this.search_ipt = this.default_key
          this.params.keyword = this.default_key
        }
        this.params.page = 1
        this.getForumList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    handleDropdown(val) {
      this.drop_val = val
    },
    haddleScreenDropdown(name) {
      this.screen_active = name
    },
    /**
     * 点击已选择项取消事件
     */
    handleCancelOption(item) {
      if (!this.list_loading) {
        switch (item.type) {
          case 'keyword':
            this.params.keyword = ''
            this.search_ipt = ''
            break;
          default:
            this.params[item.type] = ''
        }
        this.clearGetList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
    /**
     * 清空已选择项
     */
    handleClearOption() {
      this.params = {
        type: '',
        province: '',
        days: '',
        forum_scale: '',
        keyword: '',
        page: 1
      }
      this.search_ipt = ''
      this.getForumList()
    },
    handleChangePage(val) {
      this.params.page = val
      this.getForumList()
      $('html, body').animate({
        scrollTop: 0
      }, 200)
    },
    clearGetList() {
      if (!this.list_loading) {
        this.params.page = 1
        this.getForumList()
      } else {
        this.$Message.loading("数据正在加载中，请勿重复操作！")
      }
    },
  },
  created() {
    this.search_phd = this.default_key ? (this.default_key.length > 10 ? this.default_key.substr(0, 9).concat('...') : this.default_key) : '请输入关键字'
    if (this.$store.state.activity_params != '') {
      this.params = { ...this.$store.state.activity_params }
      this.params.page = 1
      this.sort_id = this.params.sort_type
    }
    this.getMeta(['forum_scale', 'forum_type', 'forum_province'], this.forumNum)
    this.getForumList()
    let url = window.location.href
    this.getAddPuv(url)
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('right_column', 20)
      }
      window.onresize = () => {
        this.listenerScroll('right_column', 20)
      }
    })
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
  beforeDestroy() {
    this.$store.commit('updateActivityParams', this.params)
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/rightColumn.stylus'
.a-list
  display: flex
  padding: 80px 0 40px
  .list-l
    flex: 0 0 208px
    .right_column
      top: 144px
      width: 208px
      >>> .ivu-radio-group
        display: table
  .list-r
    flex: 0 0 976px
    margin-left: 16px
    .list-header
      commonBgColor(#2a2f42, #FFFAF5)
      height: 50px
      padding-left: 50px
      p
        font-weight:400
        commonColor(#FFFFFF, #666666)
        line-height:20px
        padding-top: 15px
        font-size: 14px
    .list-content
      position: relative
      commonBgColor(#1F2330, #FFFFFF)
      &.load
        min-height: 470px
      >>> .ivu-spin-fix .ivu-spin-main
        top: 213px
      ul
        padding: 0 50px
        li
          padding: 20px 0
          display: flex
          &+li
            border-top: 1px solid
            commonBorderColor(#40444F, #F3F3F3)
          .a
            &-img
              position: relative
              flex: 0 0 200px
              height: 126px
              overflow: hidden
              cursor: pointer
              img
                width: 100%
                height: 100%
                transition_02s()
              &:hover
                img
                  transform: scale(1.05, 1.05)
            &-info
              margin-left: 20px
              position: relative
              flex: auto
            &-title
              font-size:18px
              font-weight:600
              commonColor(#e9e9eb, #333333)
              line-height:26px
              max-height: 26px
              display: -webkit-box
              overflow: hidden
              text-overflow: ellipsis
              word-break: break-all
              -webkit-box-orient: vertical
              -webkit-line-clamp: 1
              cursor: pointer
              &:hover
                color: rgba(250, 122, 80, 1) !important
            &-state
              margin-top: 8px
              img
                width: 40px
            &-address
            &-dec
              commonColor(#BCBDC1, #666666)
              font-size:12px
              margin-top: 20px
              i
                font-size: 12px
                margin-right: 8px
            &-dec
              margin-top: 16px
              span
                display: inline-block
                vertical-align: top
                &+span
                  margin-left: 50px
    .list-bottom
      .page
        margin-top: 28px
  >>> .scr_att_cnt
    margin-top: 15px
</style>
